import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";
import { useSeo } from "../components/SEO";
import { Button } from "../components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  const { t } = useI18n();
  useSeo(t("notFound.title"));
  return (
    <section className="flex min-h-[60vh] items-center justify-center bg-[#F9F6F0] px-5" data-testid="not-found">
      <div className="text-center">
        <p className="font-display text-7xl text-[#2A9D8F]">404</p>
        <h1 className="mt-3 font-display text-3xl">{t("notFound.title")}</h1>
        <p className="mt-2 text-[#5C6370]">{t("notFound.body")}</p>
        <Button asChild className="mt-6 rounded-full min-h-[48px] bg-[#2A9D8F] px-7 hover:bg-[#21867A]">
          <Link to="/" data-testid="notfound-home"><Home className="mr-2 h-5 w-5" /> {t("common.backHome")}</Link>
        </Button>
      </div>
    </section>
  );
}
